export default {
  name: "FormWithTabs",
  props: {
    // 主表单数据
    data: {
      type: Object,
      required: true
    },
    // 主表单显示信息
    formInfo: {
      type: Object,
      default: () => ({})
    },
    // tabs配置参数
    tabs: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      activeTab: '0'
    }
  },
  methods: {
    // 处理表单控件值变化
    handleValueChange(field, value) {
      this.$emit('input', { ...this.data, [field]: value });
    },
    
    // 图片上传处理方法
    handleImageUpload(file, field) {
      let fd = new FormData();
      fd.append('file', file.raw);
      
      // 这里需要根据实际的上传接口进行调整
      this.$http.post('/upload/image', fd, {headers: {'Content-Type': 'multipart/form-data'}})
        .then(response => {
          this.handleValueChange(field, response.data);
        })
        .catch(error => {
          console.error('图片上传失败:', error);
          this.$message.error('图片上传失败');
        });
    }
  },
  render(h) {
    const { formInfo, tabs, data } = this;
    
    // 创建表单项
    const renderFormItem = (item,isMain = false) => {
      const commonProps = isMain ? {
        props: {
          value: data[item.field],
          disabled: item.disabled || false,
          placeholder: item.placeholder || `请输入${item.label}`
        },
        on: {
          input: (value) => this.handleValueChange(item.field, value)
        }
      } : {
        props: {
          value: data[item.field],
          disabled: item.disabled || false,
          placeholder: item.placeholder || `请输入${item.label}`
        },
        style: {
          width: '175px'
        },
        on: {
          input: (value) => this.handleValueChange(item.field, value)
        }
      };
      
      let component;
      switch (item.type) {
        case 'input':
          component = h('el-input', commonProps);
          break;
        case 'select':
          component = h('el-select', {
            ...commonProps,
            props: {
              ...commonProps.props,
              clearable: true
            }
          }, item.options ? item.options.map(option => 
            h('el-option', {
              props: {
                label: option.label,
                value: option.value
              }
            })
          ) : []);
          break;
        case 'date':
          component = h('el-date-picker', {
            ...commonProps,
            props: {
              ...commonProps.props,
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd'
            }
          });
          break;
        case 'switch':
          component = h('el-switch', {
            ...commonProps,
            props: {
              ...commonProps.props,
              activeValue: true,
              inactiveValue: false
            }
          });
          break;
        case 'radio':
          component = h('el-radio-group', commonProps, 
            item.options ? item.options.map(option => 
              h('el-radio', {
                props: { label: option.value }
              }, option.label)
            ) : []
          );
          break;
        case 'checkbox':
          component = h('el-checkbox-group', commonProps,
            item.options ? item.options.map(option => 
              h('el-checkbox', {
                props: { label: option.value }
              }, option.label)
            ) : []
          );
          break;
        // 添加图片类型支持
        case 'image':
          const imageSrc = data[item.field] ? `https://gate.yilanbiaoge.cn/back/getImage/${data[item.field]}` : '';
          component = h('div', [
            data[item.field] ? h('el-popover', {
              props: {
                placement: 'right',
                trigger: 'hover'
              },
              scopedSlots: {
                default: () => h('img', {
                  attrs: {
                    src: imageSrc
                  },
                  style: {
                    width: '500px',
                    height: '500px'
                  }
                }),
                reference: () => h('img', {
                  attrs: {
                    src: imageSrc
                  },
                  style: {
                    width: '100px',
                    height: '100px',
                    marginBottom: '10px'
                  }
                })
              }
            }) : null,
            h('el-upload', {
              props: {
                action: '',
                'show-file-list': false,
                'auto-upload': false
              },
              on: {
                change: (file) => this.handleImageUpload(file, item.field)
              }
            }, [
              h('el-button', {
                props: {
                  size: 'small'
                }
              }, '点击上传')
            ])
          ]);
          break;
        default:
          component = h('el-input', commonProps);
      }
      
      return h('el-form-item', {
        props: {
          label: item.label,
          prop: item.field
        }
      }, [component]);
    };
    
    // 创建tabs内容
    const renderTabs = () => {
      return tabs.map((tab, index) => {
        const formItems = tab.formItems ? tab.formItems.map(item => renderFormItem(item)) : [];
        
        return h('el-tab-pane', {
          props: {
            label: tab.name,
            name: String(index)
          },
          key: index
        }, [
          h('el-form', {
            props: {
              model: data,
              labelWidth: formInfo.labelWidth || '100px',
              inline: true,
              ...formInfo
            }
          }, formItems)
        ]);
      });
    };

    const formItems = [
      ...formInfo.formMain.map(main => renderFormItem(main, true)),

      h('el-tabs', {
        props: {
          value: this.activeTab
        },
        on: {
          'input': (val) => { this.activeTab = val; }
        }
      }, renderTabs())
    ]

    // 主渲染函数
    return h('el-form', {
      props: {
        model: data,
        labelWidth: formInfo.labelWidth || '100px',
        ...formInfo
      }
    }, formItems);
  }
}